import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import NewAnalysis from "@/pages/NewAnalysis";
import AnalysisReport from "@/pages/AnalysisReport";
import Payments from "@/pages/Payments";
import Billing from "@/pages/Billing";
import AdminDashboard from "@/pages/AdminDashboard";
import Legal from "@/pages/Legal";
import CookieBanner from "@/components/CookieBanner";
import InstallPWA from "@/components/InstallPWA";
import PublicReport from "@/pages/PublicReport";
import HistoricalCompare from "@/pages/HistoricalCompare";
import DemoReport from "@/pages/DemoReport";
import BankAudit from "@/pages/BankAudit";
import TruthMachine from "@/pages/TruthMachine";
import AsesoriaEmpresas from "@/pages/AsesoriaEmpresas";
import PortalAsesor from "@/pages/PortalAsesor";
import PortalAsesorCliente from "@/pages/PortalAsesorCliente";
import PortalDirectorio from "@/pages/PortalDirectorio";
import PortalSubidaMasiva from "@/pages/PortalSubidaMasiva";
import Verifactu from "@/pages/Verifactu";
import AuthCallback from "@/pages/AuthCallback";
import Profile from "@/pages/Profile";

function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <span className="elegant-loader"><span /><span /><span /></span>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

function AppRoutes() {
    // Detección síncrona del callback OAuth ANTES de que se resuelvan las rutas protegidas.
    // Debe leerse desde useLocation() (reactivo) — no window.location.hash.
    const location = useLocation();
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/registro" element={<Register />} />
            <Route path="/recuperar-contrasena" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/analisis/nuevo" element={<ProtectedRoute><NewAnalysis /></ProtectedRoute>} />
            <Route path="/analisis/:id" element={<ProtectedRoute><AnalysisReport /></ProtectedRoute>} />
            <Route path="/analisis/:id/auditoria-bancaria" element={<ProtectedRoute><BankAudit /></ProtectedRoute>} />
            <Route path="/pagos" element={<ProtectedRoute><Payments /></ProtectedRoute>} />
            <Route path="/pagos/exito" element={<ProtectedRoute><Payments /></ProtectedRoute>} />
            <Route path="/facturacion" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
            <Route path="/mis-compras" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/portal-asesor" element={<ProtectedRoute><PortalAsesor /></ProtectedRoute>} />
            <Route path="/portal-asesor/subida-masiva" element={<ProtectedRoute><PortalSubidaMasiva /></ProtectedRoute>} />
            <Route path="/portal-asesor/:id" element={<ProtectedRoute><PortalAsesorCliente /></ProtectedRoute>} />
            <Route path="/portal-asesor/:id/directorio" element={<ProtectedRoute><PortalDirectorio /></ProtectedRoute>} />
            <Route path="/verifactu" element={<ProtectedRoute><Verifactu /></ProtectedRoute>} />
            <Route path="/perfil" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/aviso-legal" element={<Legal kind="aviso" />} />
            <Route path="/privacidad" element={<Legal kind="privacidad" />} />
            <Route path="/cookies" element={<Legal kind="cookies" />} />
            <Route path="/i/:token" element={<PublicReport />} />
            <Route path="/demo" element={<DemoReport />} />
            <Route path="/maquina-verdad" element={<ProtectedRoute><TruthMachine /></ProtectedRoute>} />
            <Route path="/asesoria/empresas" element={<ProtectedRoute><AsesoriaEmpresas /></ProtectedRoute>} />
            <Route path="/comparativa" element={<ProtectedRoute><HistoricalCompare /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRoutes />
                    <CookieBanner />
                    <InstallPWA />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
